import classNames from 'classnames';
import { useFormikContext } from 'formik';
import React from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { CreateApplicationFormValues } from '../../views/ApplicationCreate';

const ApplicationOtherCreate = (): React.ReactElement => {
  const { t } = useTranslation(['createApplication', 'common']);
  const { errors, touched, getFieldProps } = useFormikContext<CreateApplicationFormValues>();

  return (
    <Card className="mb-2">
      <Card.Body>
        <Row>
          <Col>
            <h4>{t('other')}</h4>
          </Col>
        </Row>
        <Row>
          <Col md="4">
            <p className="small text-muted">{t('otherHelp')}</p>
          </Col>
          <Col md="8">
            {' '}
            <Form.Group controlId="otherInformation">
              <Form.Label>{t('otherInformation')}:</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                type="text"
                className={classNames({
                  'is-invalid': touched.otherInformation && errors.otherInformation,
                })}
                {...getFieldProps('otherInformation')}
              />
            </Form.Group>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};
export default ApplicationOtherCreate;
